import React from 'react'

const SvgPersonExercising = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M18.5 7.99a2 2 0 11-4 0 2 2 0 014 0z' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M17.174 3.76a1 1 0 00-1.302-1.518c-2.826 2.425-4.448 4.393-6.43 7.766-1.164 1.98-2.143 4.694-2.822 6.858a60.444 60.444 0 00-1.093 3.904 1 1 0 00.742 1.204 1.01 1.01 0 001.205-.746c.304-1.266.665-2.52 1.055-3.763.176-.561.37-1.15.578-1.744l.832.362 2.667 5.348s.392.875 1.336.448c.87-.394.47-1.297.47-1.297l-2.629-5.216 4.51-1.716a1 1 0 00.38-1.614l-3.06-3.311a1 1 0 01-.033-1.32l.307-.368c.935-1.13 1.966-2.144 3.287-3.278zm-4.315 9.068l.584-1.279.75.794-1.334.485z'
    />
  </svg>
)

export default SvgPersonExercising
